<template>
    <el-dialog title="在途登记信息"
        :visible.sync="onTheWayVisiable"
        width="90%"
        class="on-the-way-dialog"
        :close-on-click-modal="false"
        :before-close="handleClose">
        <div slot="title" class="header-title">
            <span>发车单号：<span>{{rowData.dispatchNo}} / 司机：{{rowData.driver}} / {{rowData.vehicleCard}} / {{rowData.driverContactWay}}</span></span>
        </div>
        <div class="content">
            <div class="cont-left">
                <div class="title">订单信息：</div>
                <el-table :data="taskTableData" border :height="300" highlight-current-row :row-class-name="tableRowClassName" :row-key="getRowKeys"
                    ref='moduleTable' @selection-change="handleSelChange" @select="handleSel" @row-click="rowClick">
                    <el-table-column fixed="left" type="selection" width="55" :selectable="selectable"></el-table-column>
                    <el-table-column show-overflow-tooltip label="客户订单号" prop="customerOrderNo" min-width="160"></el-table-column>
                    <el-table-column show-overflow-tooltip label="运单号" prop="waybillNo" min-width="126"></el-table-column>
                    <el-table-column show-overflow-tooltip label="状态" prop="taskStatusName" min-width="76"></el-table-column>
                </el-table>
            </div>
            <div class="cont-center">
                <div class="title">路由登记：</div>
                <el-form ref="editForm" label-position="right" label-width="10px" :model="editData">
                    <el-form-item label="" prop="addrArr">
                        <otpAllAddressSelect
                            :minLayers="3"
                            v-model="editData.addrArr"
                            @getAddress="getAddress"
                            :disabled="editDisabled"
                            placeholder="请选择三级地址"
                        ></otpAllAddressSelect>
                    </el-form-item>
                    <el-form-item label="" prop="detailAddr">
                        <el-input v-model="editData.detailAddr" :disabled="editDisabled" maxlength="30" show-word-limit autosize clearable  placeholder="请输入详细地址"></el-input>
                    </el-form-item>
                    <el-form-item label="" prop="expectedDeliveryTime">
                        <el-date-picker
                            v-model="editData.expectedDeliveryTime"
                            :disabled="editDisabled"
                            placeholder="预计到达时间"
                            type="datetime">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item prop="remark" label="">
                        <el-input class="remark" v-model="editData.remark" :disabled="editDisabled" type="textarea" maxlength="50" show-word-limit autosize clearable placeholder="请输入备注"></el-input>
                    </el-form-item>
                    <el-form-item class="form-item-btn">
                        <el-button @click="resetForm('editForm')">重置</el-button>
                        <el-button type="primary" :disabled="editDisabled" :loading="saveLoading" @click="handleSave('editForm')">保存</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="cont-right">
                <div class="title">历史记录：</div>
                <div class="info-cont">
                    <div v-for="(info, index) in infoList" :key="index" class="info">
                        <div class="info-cont-left"><span class="serial-number">{{index + 1}}</span></div>
                        <div class="info-cont-right">
                            <span>{{info.provinceName}}{{info.cityName}}{{info.districtName}}{{info.detailAddr}}</span><br/>
                            <span>预计到达： {{info.expectedDeliveryTime}}</span><br/>
                            <span>备注： {{info.remark}}</span><br/>
                            <span class="info-register">登记：{{info.updateUserName}} / {{info.updateTime}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import { getTaskData, getOnTheWayData, saveOnTheWayData } from '../../../api/dispatchOrder';
import otpAllAddressSelect from '@/components/lots/otpCascader2';
import formatTime from '@/utils/common.js';
import { dictWithUrl } from '@/components/lots/api.js';

export default {
    components: { otpAllAddressSelect },
    props: {
        onTheWayVisiable: {
            type: Boolean,
            default: false
        },
        rowData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            taskTableData: [],
            selectedData: [],
            editData: {
                addrArr: [],
                detailAddr: '',
                expectedDeliveryTime: '',
                remark: '',
                provinceCode: '',
                provinceName: '',
                cityCode: '',
                cityName: '',
                districtCode: '',
                districtName: '',
                townCode: '',
                townName: ''
            },
            saveLoading: false,
            currentRow: {},
            infoList: []
        };
    },
    methods: {
        handleClose() {
            this.$emit('onTheWayClose');
        },
        handleSave(editForm) {
            this.$refs[editForm].validate((valid) => {
                if (valid) {
                    if (this.selectedData.length <= 0) return this.$message.warning('请勾选要保存的运单');
                    const taskNos = this.selectedData.map(el => el.taskNo);
                    if (this.editData.addrArr) {
                        ['provinceCode', 'cityCode', 'districtCode', 'townCode'].forEach((key, index) => {
                            this.editData[key] = this.editData.addrArr[index] || '';
                        });
                        Reflect.deleteProperty(this.editData, 'addrArr');
                    }
                    this.editData.expectedDeliveryTime = formatTime.formatDateTime(this.editData.expectedDeliveryTime);
                    const params = {
                        dispatchNo: this.rowData.dispatchNo,
                        taskNos: taskNos,
                        ...this.editData
                    };
                    this.saveLoading = true;
                    saveOnTheWayData(params).then(res => {
                        this.saveLoading = false;
                        if (res) {
                            this.$message.success('保存成功');
                            this.$emit('saveOnTheWayDataOK');
                        }
                    }).catch(() => {
                        this.saveLoading = false;
                    });
                }
            });
        },
        getInfoData() {
            const params = {
                dispatchNo: this.rowData.dispatchNo,
                taskNo: this.currentRow.taskNo,
                pageNo: 1,
                pageSize: 1000000
            };
            getOnTheWayData(params).then(res => {
                if (res) {
                    this.infoList = res.data.list || [];
                    if (this.infoList.length <= 0) {
                        this.$message.warning('没有历史记录信息');
                    }
                }
            });
        },
        async  getTaskDatas() {
            const params = {
                dispatchNo: this.rowData.dispatchNo,
                pageNo: 1,
                pageSize: 1000000,
                total: 0
            };
            const dict = await dictWithUrl('TRANSPORT_STATUS');
            const dictData = dict.data;
            getTaskData(params).then(res => {
                if (res) {
                    this.taskTableData = res.data.list || [];
                    this.taskTableData.forEach(item => {
                        item.taskStatusName = dictData.TRANSPORT_STATUS[item.taskStatus] || item.taskStatus;
                    });
                }
            });
        },
        handleSelChange(data) {
            this.selectedData = data;
        },
        rowClick(row) {
            this.currentRow = row;
            if (+row.taskStatus === 40) {
                row.checked = !row.checked;
                this.$refs.moduleTable.toggleRowSelection(row, row.checked);
            }
            this.getInfoData();
        },
        getAddress(labels) {
            if (labels) {
                ['provinceName', 'cityName', 'districtName', 'townName'].forEach((key, index) => {
                    this.editData[key] = labels[index] || '';
                });
            }
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.getAddress([]);
        },
        selectable(row, index) {
            if (+row.taskStatus === 40) {
                return true;
            } else {
                return false;
            }
        },
        handleSel(selection, row) {
            this.currentRow = row;
            this.getInfoData();
        },
        tableRowClassName({ row }) {
            if (this.selectedData && this.selectedData.map(item => item.id).includes(row.id)) {
                return 'highlight-row';
            }
        },
        getRowKeys(row) {
            if (!row.expandsRandomKey) row.expandsRandomKey = row.id + Math.random().toString().substr(-10);
            return row.expandsRandomKey;
        }
    },
    created() {
        this.getTaskDatas();
    },
    computed: {
        editDisabled() {
            return +this.rowData.originDispatchStatus !== 40;
        }
    }
};
</script>
<style lang="less">
    .on-the-way-dialog {
        .content {
            display: flex;
            font-size: 14px;
            .title {
                height: 36px;
                line-height: 36px;
            }
        }
        .cont-left {
            width: 425px;
            padding-right: 10px;
        }
        .cont-right {
            width: 500px;
            padding-left: 10px;
        }
        .cont-center {
            flex: 1;
            padding: 0 10px 0 10px;
            border-left: 1px dashed #ccc;
            border-right: 1px dashed #ccc;
            .el-form-item {
                margin-bottom: 4px;
            }
            .remark {
                .el-input__count {
                    line-height: 28px;
                    bottom: 2px;
                }
            }
        }
        .form-item-btn {
            margin-bottom: 0;
            margin-top: 30px;
            text-align: center;
        }
        .info-cont {
            height: 400px;
            overflow: auto;
        }
        .info {
            display: flex;
            padding: 10px;
            border-bottom: 1px dashed #ccc;
            .info-cont-left {
                display: flex;
                justify-content: center;
                color: #686a6a;
                align-items: center;
                margin-right: 10px;
            }
            .serial-number {
                border: 1px solid #686a6a;
                border-radius: 18px;
                display: inline-block;
                width: 18px;
                height: 18px;
                line-height: 18px;
                text-align: center;
            }
            .info-cont-right {
                flex: 1;
            }
        }
    }
</style>
